import * as z from 'zod';
import * as ba from './base';
import { CRUD } from '../connections';
import { assertComponentContext } from '../helpers';
export class CRUDAction extends ba.Action {
    static get manifest() {
        return {
            name: 'crud',
            schema: z.object({
                objectType: z.string(),
                op: z.union([z.literal('upsert'), z.literal('delete')]),
                data: z.any().optional(),
                options: z.record(z.any()).optional()
            })
        };
    }
    async handle(event, args) {
        assertComponentContext(event.component);
        const obj = CRUD.createCRUD(args.objectType, event.component.$app);
        const meth = args.op === 'delete' ? obj.delete : obj.upsert;
        await this.dispatch('before', {});
        const response = await meth.call(obj, args.data, args.options);
        await this.dispatch('success', response);
        return response;
    }
}
//# sourceMappingURL=crud.js.map